import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import * as NProgress from 'nprogress';

type Props = {};

const useNprogress = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleStart = () => NProgress.start();
  const handleStop = () => NProgress.done();

  React.useEffect(() => {
    handleStart();
    handleStop();
  }, [location.pathname]);

  return {};
};

export default useNprogress;
